import React, { FC } from 'react';
import { Route, Routes } from 'react-router-dom';
import RoleAssignmentMainPage from './role-assignment-main-page';

const RoleAssignmentsIndex: FC = () => {
  return (
    <Routes>
      <Route path={`/*`} element={<RoleAssignmentMainPage />} />
    </Routes>
  );
};

export default RoleAssignmentsIndex;
